import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';

const YouTubeEmbed = ({ videoUrl, title }) => {
  if (!videoUrl) {
    return <Typography variant="body2" color="error">No YouTube URL provided.</Typography>;
  }

  let videoId = '';

  if (videoUrl.includes('youtube.com/watch?v=')) {
    videoId = videoUrl.split('v=')[1]?.split('&')[0];
  } else if (videoUrl.includes('youtu.be/')) {
    videoId = videoUrl.split('youtu.be/')[1]?.split('?')[0];
  }

  if (!videoId) {
    return <Typography variant="body2" color="error">Invalid YouTube URL.</Typography>;
  }

  const iframeSrc = `https://www.youtube.com/embed/${videoId}`;

  return (
    <Card sx={{ maxWidth: 640, margin: 'auto', mt: 2, backgroundColor: '#000000' }}>
      <Box sx={{ position: 'relative', paddingTop: '56.25%' /* 16:9 aspect ratio */ }}>
        <iframe
          width="100%"
          height="100%"
          src={iframeSrc}
          title={title}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{ position: 'absolute', top: 0, left: 0 }}
        />
      </Box>
    </Card>
  );
};

export default YouTubeEmbed;
